import * as React from 'react'

/**
 * Renders a tree/hierarchy diagram SVG icon with connected nodes
 * @param {object} props - Component props
 * @returns {JSX.Element} Tree icon SVG element
 */
function Tree(props) {
  return (
    <svg
      fill='none'
      height={22}
      viewBox='0 0 26 27'
      width={22}
    >
      <path
        d='M13 6.999v13M4 20a6 6 0 016-6h6a6 6 0 016 6'
        stroke='#1EAEFF'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.5 1.999h-3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1zM14.5 19.999h-3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1zM5.5 19.999h-3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1zM23.5 19.999h-3a1 1 0 00-1 1v3a1 1 0 001 1h3a1 1 0 001-1v-3a1 1 0 00-1-1z'
        stroke='#1EAEFF'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
      />
    </svg>
  )
}

export default Tree
